import { Injectable, Injector } from '@angular/core'
import { Observable } from 'rxjs/Observable'

import { BaseModelService } from './base-model.service'
import { HubRegistration } from './hub-registration.model'
import { HubRegistrationSerializer } from 'serializers'

@Injectable()
export class HubRegistrationService extends BaseModelService<HubRegistration> {
  constructor() {
    super()

    this.configure({
      basePath:  'hub_registrations',
      key:       'hubRegistration',
      pluralKey: 'hubRegistrations',
      serializer: HubRegistrationSerializer
    })
  }

  getPersonalData(hubRegistrationId: string | number, type: 'phone' | 'driver_license') {
    let url = this.buildUrl(hubRegistrationId, type)
    return this.get(url)
      .map(resp => resp['value']);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/hub-registration.service.ts